export const cleanPageNumber = (url: string) => {
  return url?.replace?.(/\/page-\d*/g, '')
}

export const cleanPageNumberParam = (params: Array<string>) => {
  return params?.filter?.((item) => {
    return !item.includes('page')
  })
}
